import React, { useState } from 'react';

function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState(null);

  // Team members with WhatsApp numbers
  const teamMembers = [
    {
      name: 'Carlos Tayrun',
      role: 'Director General',
      phone: '+595981123456',
      avatar: '👨‍💼',
      color: 'linear-gradient(135deg, #334155 0%, #1e293b 100%)'
    },
    {
      name: 'María González',
      role: 'Atención al Cliente',
      phone: '+595981234567',
      avatar: '👩‍💼',
      color: 'linear-gradient(135deg, #475569 0%, #334155 100%)'
    },
    {
      name: 'Jorge Ramírez',
      role: 'Ventas & Asesoría',
      phone: '+595981345678',
      avatar: '👨‍🔧',
      color: 'linear-gradient(135deg, #64748b 0%, #475569 100%)'
    }
  ];

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    
    try {
      await new Promise(resolve => setTimeout(resolve, 1000));
      setSubmitted(true);
      setSubmitting(false);
    } catch (error) {
      setError('Error al enviar el mensaje. Intenta de nuevo.');
      setSubmitting(false);
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const openWhatsApp = (phone) => {
    const message = encodeURIComponent('Hola! Me comunico desde la web de Herramientas Tayrun.');
    window.open(`https://wa.me/${phone.replace(/[^0-9]/g, '')}?text=${message}`, '_blank');
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-slate-100">
      {/* Hero Section */}
      <div className="relative overflow-hidden py-16" style={{background: 'linear-gradient(135deg, #1e293b 0%, #334155 100%)'}}>
        <div className="absolute inset-0" style={{backgroundImage: 'url("data:image/svg+xml,%3Csvg width="60" height="60" viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg"%3E%3Cg fill="none" fill-rule="evenodd"%3E%3Cg fill="%23ffffff" fill-opacity="0.03"%3E%3Cpath d="M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z"/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")'}}></div>
        <div className="container relative">
          <div className="row justify-content-center">
            <div className="col-lg-8 text-center">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-white/10 backdrop-blur-sm rounded-2xl mb-5 mx-auto" style={{display: 'flex', alignItems: 'center', justifyContent: 'center', width: '64px', height: '64px', margin: '0 auto 1.25rem'}}>
                <i className="fas fa-headset text-white text-3xl"></i>
              </div>
              <h1 className="display-5 fw-bold text-white mb-3">
                Contacta a Herramientas Tayrun
              </h1>
              <p className="lead mb-0" style={{color: '#94a3b8'}}>
                Estamos aquí para ayudarte. ¡Escríbenos por WhatsApp o envíanos un mensaje!
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="container py-5">
        {/* Team Section - Modern Cards with WhatsApp */}
        <div className="row justify-content-center mb-5">
          <div className="col-lg-10">
            <div className="text-center mb-4">
              <h2 className="fw-bold mb-2" style={{color: '#1e293b'}}>Nuestro Equipo</h2>
              <p className="text-muted">Contacta directamente con quien pueda ayudarte mejor</p>
            </div>
            
            <div className="row g-4 justify-content-center">
              {teamMembers.map((member, index) => (
                <div key={index} className="col-md-4">
                  <div 
                    className="card border-0 h-100 text-center" 
                    style={{
                      borderRadius: '1.25rem', 
                      boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
                      transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                      cursor: 'pointer'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = 'translateY(-8px)';
                      e.currentTarget.style.boxShadow = '0 12px 40px rgba(0,0,0,0.15)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = 'translateY(0)';
                      e.currentTarget.style.boxShadow = '0 4px 20px rgba(0,0,0,0.08)';
                    }}
                  >
                    <div className="card-body p-4">
                      {/* Avatar */}
                      <div 
                        style={{
                          width: '80px', 
                          height: '80px', 
                          background: member.color,
                          borderRadius: '50%',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          margin: '0 auto 1rem',
                          fontSize: '2.5rem',
                          boxShadow: '0 4px 14px rgba(0,0,0,0.2)'
                        }}
                      >
                        {member.avatar}
                      </div>
                      
                      {/* Info */}
                      <h5 className="fw-bold mb-1" style={{color: '#1e293b'}}>{member.name}</h5>
                      <p className="text-muted small mb-3">{member.role}</p>
                      <p className="text-muted small mb-3" style={{fontFamily: 'monospace'}}>{member.phone}</p>
                      
                      {/* WhatsApp Button */}
                      <button
                        onClick={() => openWhatsApp(member.phone)}
                        className="btn w-100"
                        style={{
                          background: 'linear-gradient(135deg, #25D366 0%, #128C7E 100%)',
                          color: 'white',
                          border: 'none',
                          borderRadius: '0.75rem',
                          padding: '0.75rem 1rem',
                          fontWeight: '600',
                          boxShadow: '0 4px 14px rgba(37, 211, 102, 0.4)',
                          transition: 'transform 0.2s ease, box-shadow 0.2s ease'
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.transform = 'scale(1.02)';
                          e.currentTarget.style.boxShadow = '0 6px 20px rgba(37, 211, 102, 0.5)';
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.transform = 'scale(1)';
                          e.currentTarget.style.boxShadow = '0 4px 14px rgba(37, 211, 102, 0.4)';
                        }}
                      >
                        <i className="fab fa-whatsapp me-2"></i>
                        Escribir por WhatsApp
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="row g-5 justify-content-center">
          {/* Contact Information */}
          <div className="col-lg-4">
            <div className="card border-0 h-100" style={{borderRadius: '1.25rem', boxShadow: '0 4px 20px rgba(0,0,0,0.08)'}}>
              <div className="card-body p-4">
                <h4 className="fw-bold mb-4" style={{color: '#1e40af'}}>
                  <i className="fas fa-info-circle me-2"></i>
                  Información de Contacto
                </h4>
                
                <div className="mb-4">
                  <div className="d-flex align-items-center mb-4">
                    <div style={{width: '48px', height: '48px', background: 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)', borderRadius: '0.75rem', display: 'flex', alignItems: 'center', justifyContent: 'center', marginRight: '1rem', boxShadow: '0 4px 14px rgba(59, 130, 246, 0.3)'}}>
                      <i className="fas fa-phone text-white"></i>
                    </div>
                    <div>
                      <h6 className="fw-bold mb-1" style={{color: '#1e293b'}}>Teléfono</h6>
                      <p className="text-muted mb-0">+595 21 123 4567</p>
                    </div>
                  </div>

                  <div className="d-flex align-items-center mb-4">
                    <div style={{width: '48px', height: '48px', background: 'linear-gradient(135deg, #25D366 0%, #128C7E 100%)', borderRadius: '0.75rem', display: 'flex', alignItems: 'center', justifyContent: 'center', marginRight: '1rem', boxShadow: '0 4px 14px rgba(37, 211, 102, 0.3)'}}>
                      <i className="fab fa-whatsapp text-white"></i>
                    </div>
                    <div>
                      <h6 className="fw-bold mb-1" style={{color: '#1e293b'}}>WhatsApp 24/7</h6>
                      <p className="text-muted mb-0">+595 981 123 456</p>
                    </div>
                  </div>

                  <div className="d-flex align-items-center mb-4">
                    <div style={{width: '48px', height: '48px', background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)', borderRadius: '0.75rem', display: 'flex', alignItems: 'center', justifyContent: 'center', marginRight: '1rem', boxShadow: '0 4px 14px rgba(245, 158, 11, 0.3)'}}>
                      <i className="fas fa-envelope text-white"></i>
                    </div>
                    <div>
                      <h6 className="fw-bold mb-1" style={{color: '#1e293b'}}>Email</h6>
                      <p className="text-muted mb-0">contacto@herramientastayrun.com.py</p>
                    </div>
                  </div>

                  <div className="d-flex align-items-center mb-4">
                    <div style={{width: '48px', height: '48px', background: 'linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)', borderRadius: '0.75rem', display: 'flex', alignItems: 'center', justifyContent: 'center', marginRight: '1rem', boxShadow: '0 4px 14px rgba(139, 92, 246, 0.3)'}}>
                      <i className="fas fa-map-marker-alt text-white"></i>
                    </div>
                    <div>
                      <h6 className="fw-bold mb-1" style={{color: '#1e293b'}}>Ubicación</h6>
                      <p className="text-muted mb-0">Asunción, Paraguay</p>
                    </div>
                  </div>

                  <div className="d-flex align-items-center">
                    <div style={{width: '48px', height: '48px', background: 'linear-gradient(135deg, #06b6d4 0%, #0891b2 100%)', borderRadius: '0.75rem', display: 'flex', alignItems: 'center', justifyContent: 'center', marginRight: '1rem', boxShadow: '0 4px 14px rgba(6, 182, 212, 0.3)'}}>
                      <i className="fas fa-clock text-white"></i>
                    </div>
                    <div>
                      <h6 className="fw-bold mb-1" style={{color: '#1e293b'}}>Horario</h6>
                      <p className="text-muted mb-0">Lun-Vie: 8:00 - 18:00</p>
                    </div>
                  </div>
                </div>

                <div className="mt-4 pt-4" style={{borderTop: '1px solid #e2e8f0'}}>
                  <h6 className="fw-bold mb-3" style={{color: '#1e293b'}}>Síguenos</h6>
                  <div className="d-flex gap-2">
                    <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="btn" style={{background: '#1877f2', color: 'white', borderRadius: '0.5rem', width: '40px', height: '40px', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                      <i className="fab fa-facebook-f"></i>
                    </a>
                    <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="btn" style={{background: 'linear-gradient(45deg, #f09433, #e6683c, #dc2743, #cc2366, #bc1888)', color: 'white', borderRadius: '0.5rem', width: '40px', height: '40px', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                      <i className="fab fa-instagram"></i>
                    </a>
                    <a href="https://tiktok.com" target="_blank" rel="noopener noreferrer" className="btn" style={{background: '#000', color: 'white', borderRadius: '0.5rem', width: '40px', height: '40px', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                      <i className="fab fa-tiktok"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Contact Form */}
          <div className="col-lg-6">
            <div className="card border-0" style={{borderRadius: '1.25rem', boxShadow: '0 4px 20px rgba(0,0,0,0.08)'}}>
              <div className="card-body p-4">
                <h4 className="fw-bold mb-4" style={{color: '#1e40af'}}>
                  <i className="fas fa-paper-plane me-2"></i>
                  Envía tu Mensaje
                </h4>
                
                {submitted ? (
                  <div className="text-center py-5">
                    <div style={{width: '80px', height: '80px', background: 'linear-gradient(135deg, #22c55e 0%, #16a34a 100%)', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 1.5rem', boxShadow: '0 4px 14px rgba(34, 197, 94, 0.4)'}}>
                      <i className="fas fa-check text-white fa-2x"></i>
                    </div>
                    <h4 className="fw-bold mb-2" style={{color: '#166534'}}>¡Mensaje Enviado!</h4>
                    <p className="text-muted mb-4">Te responderemos lo antes posible.</p>
                    <button 
                      onClick={() => {setSubmitted(false); setFormData({name: '', email: '', subject: '', message: ''});}}
                      className="btn"
                      style={{background: 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)', color: 'white', borderRadius: '0.75rem', padding: '0.75rem 2rem'}}
                    >
                      Enviar otro mensaje
                    </button>
                  </div>
                ) : (
                  <form onSubmit={handleSubmit}>
                    <div className="row g-3">
                      <div className="col-md-6">
                        <label htmlFor="name" className="form-label fw-semibold" style={{color: '#374151'}}>
                          Nombre Completo *
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="name"
                          name="name"
                          value={formData.name}
                          onChange={handleChange}
                          required
                          placeholder="Tu nombre"
                          style={{borderRadius: '0.75rem', border: '2px solid #e5e7eb', padding: '0.75rem 1rem'}}
                        />
                      </div>
                      
                      <div className="col-md-6">
                        <label htmlFor="email" className="form-label fw-semibold" style={{color: '#374151'}}>
                          Email *
                        </label>
                        <input
                          type="email"
                          className="form-control"
                          id="email"
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                          required
                          placeholder="tu@email.com"
                          style={{borderRadius: '0.75rem', border: '2px solid #e5e7eb', padding: '0.75rem 1rem'}}
                        />
                      </div>
                      
                      <div className="col-12">
                        <label htmlFor="subject" className="form-label fw-semibold" style={{color: '#374151'}}>
                          Asunto *
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="subject"
                          name="subject"
                          value={formData.subject}
                          onChange={handleChange}
                          required
                          placeholder="¿En qué podemos ayudarte?"
                          style={{borderRadius: '0.75rem', border: '2px solid #e5e7eb', padding: '0.75rem 1rem'}}
                        />
                      </div>
                      
                      <div className="col-12">
                        <label htmlFor="message" className="form-label fw-semibold" style={{color: '#374151'}}>
                          Mensaje *
                        </label>
                        <textarea
                          className="form-control"
                          id="message"
                          name="message"
                          rows="4"
                          value={formData.message}
                          onChange={handleChange}
                          required
                          placeholder="Escribe tu mensaje aquí..."
                          style={{borderRadius: '0.75rem', border: '2px solid #e5e7eb', padding: '0.75rem 1rem', resize: 'none'}}
                        ></textarea>
                      </div>
                      
                      <div className="col-12">
                        <button 
                          type="submit" 
                          className="btn btn-lg w-100"
                          disabled={submitting}
                          style={{
                            background: 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)',
                            color: 'white',
                            border: 'none',
                            borderRadius: '0.75rem',
                            padding: '1rem',
                            fontWeight: '600',
                            boxShadow: '0 4px 14px rgba(59, 130, 246, 0.4)'
                          }}
                        >
                          {submitting ? (
                            <>
                              <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                              Enviando...
                            </>
                          ) : (
                            <>
                              <i className="fas fa-paper-plane me-2"></i>
                              Enviar Mensaje
                            </>
                          )}
                        </button>
                      </div>
                    </div>
                  </form>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* FAQ Section */}
        <div className="row justify-content-center mt-5">
          <div className="col-lg-10">
            <div className="card border-0" style={{borderRadius: '1.25rem', boxShadow: '0 4px 20px rgba(0,0,0,0.08)'}}>
              <div className="card-body p-4">
                <h4 className="fw-bold mb-4 text-center" style={{color: '#1e40af'}}>
                  <i className="fas fa-question-circle me-2"></i>
                  Preguntas Frecuentes
                </h4>
                
                <div className="row g-4">
                  <div className="col-md-6">
                    <div className="p-3" style={{background: '#f8fafc', borderRadius: '0.75rem'}}>
                      <h6 className="fw-bold" style={{color: '#1e40af'}}>
                        <i className="fas fa-shipping-fast me-2"></i>
                        ¿Cómo funciona la entrega?
                      </h6>
                      <p className="text-muted small mb-0">
                        Entregamos en todo Paraguay. Plazo estimado: 3-7 días hábiles según tu ubicación.
                      </p>
                    </div>
                  </div>
                  
                  <div className="col-md-6">
                    <div className="p-3" style={{background: '#f8fafc', borderRadius: '0.75rem'}}>
                      <h6 className="fw-bold" style={{color: '#1e40af'}}>
                        <i className="fas fa-credit-card me-2"></i>
                        ¿Qué formas de pago aceptan?
                      </h6>
                      <p className="text-muted small mb-0">
                        Efectivo, transferencia bancaria, tarjetas de crédito/débito y pago contra entrega.
                      </p>
                    </div>
                  </div>
                  
                  <div className="col-md-6">
                    <div className="p-3" style={{background: '#f8fafc', borderRadius: '0.75rem'}}>
                      <h6 className="fw-bold" style={{color: '#1e40af'}}>
                        <i className="fas fa-undo me-2"></i>
                        ¿Tienen garantía los productos?
                      </h6>
                      <p className="text-muted small mb-0">
                        Sí, todos nuestros productos tienen garantía. El plazo varía según el fabricante.
                      </p>
                    </div>
                  </div>
                  
                  <div className="col-md-6">
                    <div className="p-3" style={{background: '#f8fafc', borderRadius: '0.75rem'}}>
                      <h6 className="fw-bold" style={{color: '#1e40af'}}>
                        <i className="fas fa-headset me-2"></i>
                        ¿Cómo puedo obtener asesoría?
                      </h6>
                      <p className="text-muted small mb-0">
                        ¡Escríbenos por WhatsApp! Nuestro equipo está listo para asesorarte en tu compra.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;
